<template>
  <v-card-title class="headline primary white--text">
    <div class="title">
      {{ label }}
      <em
        v-if="sublabel"
        class="mt-2"
      >
        {{ sublabel }}
      </em>
    </div>
    <v-spacer />
    <v-btn
      icon
      dark
      :disabled="disabled"
      @click="close"
    >
      <v-icon>close</v-icon>
    </v-btn>
  </v-card-title>
</template>

<script>
export default {
  name: 'ElacCardTitle',

  props: {
    label: { type: String, default: '' },
    sublabel: { type: String, default: '' },
    disabled: { type: Boolean },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="stylus" scoped>
.title {
    font-size: 50%;

    em {
        display: block;
        font-size: 80%;
    }
}
</style>
